import { useMemo, useCallback } from 'react';
import { useQueryClient } from 'react-query';
import { useMachine } from '@xstate/react';

import { setSiteVerification } from '~/api/routes/domainVerification';

import { getCurrentLink } from '~/state/Campaign/selectors';
import { useStateBus } from '~/state/bridge';

import { usePageQuery } from '~/theseus/hooks/queries';

import verificationMachine from './machine';

export default function useDomainVerification() {
  const queryClient = useQueryClient();
  const link = useStateBus(getCurrentLink);
  const [page] = usePageQuery();

  const [state, send] = useMachine(verificationMachine, {
    services: {
      verifyDns: (_, evt) => async (cb) => {
        try {
          await setSiteVerification(evt.data);

          queryClient.invalidateQueries(['domain-verification', link, page]);
          setTimeout(() => cb('VERIFIED'), 2000);
        } catch (e) {
          if (e.data?.includes('not owner')) {
            setTimeout(() => cb('ERROR_FINAL_NOT_OWNER'), 2000);
          } else {
            setTimeout(() => cb('ERROR'), 2000);
          }
        }
      },
    },
  });

  const next = useCallback(() => send('NEXT'), [send]);
  const back = useCallback(() => send('BACK'), [send]);

  const verifyDNS = useCallback((record) => {
    send({ type: 'VERIFY_DNS', data: record });
  }, [send]);

  return useMemo(() => ({
    current: state,
    next,
    back,
    verifyDNS,
    retriesLeft: state.context.retriesLeft,
  }), [next, back, verifyDNS, state]);
}
